import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Restaurant } from '@/models';
import { FindAChipotleClickEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgRestaurantAddressItem',
})
export default class CmgRestaurantAddressItem extends Vue {
  @Prop({ required: true, default: {}, type: Object })
  restaurant!: Restaurant;

  @Prop({ default: false, type: Boolean })
  loading!: boolean;

  @Prop({ default: '', type: String })
  heartIconId!: string;

  @Prop({ default: false, type: Boolean })
  disabled!: boolean;

  heartHover = false;

  get pillType(): string {
    return this.restaurant.digitalKitchen ? 'DIGITAL KITCHEN' : this.restaurant.chipotlanePickupEnabled ? 'CHIPOTLANE' : this.restaurant.walkupWindowEnabled ? 'WALK-UP' : '';
  }

  get isLoggedIn(): boolean | undefined {
    return this.$services.customer.isLoggedIn();
  }

  get isDisabled(): boolean {
    return (this.disabled === true) || !this.restaurantAddress;
  }

  get showRestaurantsWithNoAddress(): boolean {
    return this.$services.config.showRestaurantsWithNoAddress();
  }

  getHeartIcon(): string {
    return this.$services.customer.isFavoriteRestaurant(this.restaurant.restaurantNumber)
      ? this.$appStore.state.cms.images.icons.heartFilled.default
      : this.heartHover
      ? this.$appStore.state.cms.images.icons.heartHovered.default
      : this.$appStore.state.cms.images.icons.heartEmpty.default;
  }

  toggleFavorite(event: MouseEvent) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    event.stopPropagation();
    if (this.$services.customer.isFavoriteRestaurant(this.restaurant.restaurantNumber)) {
      this.$services.customer.removeFavoriteRestaurant(this.restaurant.restaurantNumber);
      (this.$refs.heart as HTMLElement).dispatchEvent(new Event('mouseleave'));
    } else {
      this.$services.analytics.send(new FindAChipotleClickEvent('restaurantFavorited', this.restaurant.restaurantNumber));
      this.$services.ui.setModalVisibility('favoriteRestaurant', true, { restaurantNumber: this.restaurant.restaurantNumber });
      this.$services.ui.firstFocus();
    }
  }

  getFavoriteRestaurantName(): string | undefined {
    return this.$services.customer.getFavoriteRestaurantName(this.restaurant.restaurantNumber);
  }

  get restaurantAddress(): string {
    return (this.restaurant && this.restaurant.address && this.restaurant.address.addressLine1) || '';
  }

  getRestaurantCrossStreets(): string {
    if (!this.restaurant.directions) {
      return '';
    }

    const directions = this.restaurant.directions;

    if (directions.crossStreet1 && directions.crossStreet2) {
      return `Near ${directions.crossStreet1} and ${directions.crossStreet2}`;
    }

    if (directions.crossStreet1) {
      return `Near ${directions.crossStreet1}`;
    }

    if (directions.crossStreet2) {
      return `Near ${directions.crossStreet2}`;
    }

    return '';
  }

  onClickAddress() {
    if (this.isDisabled) {
      return;
    }

    this.$emit('restaurant-selected', this.restaurant);
    this.$services.ui.firstFocus();
  }

  onMouseOverDetails() {
    this.$emit('mouseover-restaurant', this.restaurant);
  }

  onMouseLeaveDetails() {
    this.$emit('mouseleave-restaurant', this.restaurant);
  }
}
